import React from "react";

const getPropsFromChildren = <
  CHILDREN extends React.ReactNode,
  PROPS extends Record<string, any>,
  VALIDATE extends (output: PROPS) => string | undefined
>(
  children: CHILDREN,
  props: PROPS,
  validate?: VALIDATE
) => {
  const output: Record<string, any> = {};

  Object.entries(props).forEach(([propName, Component]) => {
    React.Children.forEach(children, (child) => {
      try {
        if ((child as React.ReactElement).type === Component) {
          output[propName] = child as JSX.Element;
        }
      } catch (_) {
        // do nothing
      }
    });
  });

  if (validate) {
    const validationOutput = validate(output as PROPS);
    if (validationOutput) throw new Error(validationOutput);
  }
  return output as PROPS;
};

export default getPropsFromChildren;
